import * as Yup from 'yup';

import { http } from 'lib/services/http';
import {
  CRM_TEAM_SEARCH_URL,
  CRM_USER_SEARCH_URL,
  crmUpdatePath,
} from 'utils/crm-helpers';
import { yupErrorHandler } from 'api/apiUtils';

const CRM_RESOURCE_URL = '/v1/services/resources';

const modelCRM = Yup.object().shape({
  teamId: Yup.number().integer().positive().required(),
  userId: Yup.number().integer().positive().required(),
});

export const updateUserDeps = (userId: string, teamId: string) => {
  // Define the URL path params
  const params = {
    id: userId,
    type: 'agent',
  };

  // Validate the model and call the CRM API
  return modelCRM
    .validate({ teamId, userId })
    .then(() => {
      return http.post(`${crmUpdatePath(params)}/relationships/deps`, {
        data: [{ id: `${teamId}`, type: 'department' }],
      });
    })
    .catch((err) => {
      throw yupErrorHandler(err.errors);
    });
};

export const patchUserPrimaryTeam = (userId: string, teamId: string) => {
  // Define the URL path params
  const params = {
    id: userId,
    type: 'agent',
  };

  // Validate the model and call the CRM API
  return modelCRM
    .validate({ teamId, userId })
    .then(() => {
      return http.patch(
        `${crmUpdatePath(params)}/relationships/default_department`,
        {
          data: { id: `${teamId}`, type: 'department' },
        },
      );
    })
    .catch((err) => {
      throw yupErrorHandler(err.errors);
    });
};

const model = Yup.number().integer().positive().required();

export const getCrmDepartment = (ssoId: string) => {
  // Define the URL path params
  const params = {
    params: {
      'filter[sso_role_id]': ssoId,
    },
  };

  // Validate the model and call the CRM API
  return model
    .validate(ssoId)
    .then(() => {
      return http.get(CRM_TEAM_SEARCH_URL, params);
    })
    .catch((err) => {
      throw yupErrorHandler(err.errors);
    });
};

export const getCrmDefaultDepartment = async (agentId: string) => {
  try {
    await model.validate(agentId);

    return http.get(`${CRM_USER_SEARCH_URL}/${agentId}`);
  } catch (err) {
    throw yupErrorHandler(err.errors);
  }
};

export const getServiceResources = () => {
  return http.get(CRM_RESOURCE_URL);
};
